// 数据上报SDK
import { DataAnalytic } from "@ht/utils";
import { useUserInfoStore } from "@/stores/user-info";
import { isInHelloTalk } from "ht-tool";

const { track, login, logout, quick, userUniqAppend, timeEvent } = DataAnalytic(
  {
    // 提供默认配置，可以覆盖掉。一般传入这个够了
    appId: import.meta.env.VITE_APP_THINKINGDATA_APP_ID,
    showLog: false
  }
);

export const initThinkingData = () => {
  quick("autoTrack");
  if (isInHelloTalk()) {
    // 在HelloTalk中，调用login方法
    const userInfoStore = useUserInfoStore();
    if (userInfoStore?.getUserInfo?.userId) {
      console.log(
        "数据埋点调用login方法, uid ->",
        userInfoStore?.getUserInfo?.userId
      );
      // 设置账号 ID
      login(userInfoStore?.getUserInfo?.userId);
    } else {
      console.log(
        "数据埋点调用login方法, uid为空 ->",
        userInfoStore?.getUserInfo?.userId
      );
    }
  } else {
    // 不在HelloTalk中，清除账号 ID
    logout();
  }
};

export default { timeEvent, track, login, quick, userUniqAppend, logout };
